import { useState } from 'react';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';

const ImageZoomComponent = ({ image, altText, widgetID }) => {
  const [isHovered, setIsHovered] = useState(false);
  if (!image) return null;
  return (
    <WidgetIdWrapper widgetID={widgetID}>
      <div className="image-zoom-widget">
        <div
          className="zoom-container"
          style={{ transform: isHovered ? 'scale(1.35)' : 'scale(1)' }}
        >
          <img
            className="image"
            src={image}
            alt={altText ?? ''}
            onMouseLeave={() => setIsHovered(false)}
          />

          <span
            onMouseEnter={() => setIsHovered(true)}
            className="material-icons-outlined zoom-icon"
            style={{ transform: isHovered ? 'scale(calc(1/1.35))' : '' }}
          >
            zoom_in
          </span>
        </div>
      </div>
    </WidgetIdWrapper>
  );
};

export default withWidgetSpacingWrapper(ImageZoomComponent);
